import { create } from 'zustand';
import authService from '../services/authService';

export const useAuthStore = create((set, get) => ({
  // Hidrata o estado inicial a partir dos dados de UI salvos no sessionStorage.
  // O token JWT nunca é lido aqui — é gerenciado pelo browser via cookie httpOnly.
  usuario: authService.getUsuarioAtual(),
  isAutenticado: authService.isAutenticado(),
  isLoading: false,
  erro: null,
  emailTemporario: null,
  mfaTokenTemporario: null,

  login: async (email, senha) => {
    set({ isLoading: true, erro: null });
    try {
      const data = await authService.login(email, senha);

      if (data && data.requires2Fa) {
        // Guardar email e mfaToken para a etapa de verificação 2FA
        set({
          isLoading: false,
          emailTemporario: email,
          mfaTokenTemporario: data.mfaToken,
        });
        return data;
      }

      // Login sem 2FA: cookie já setado pelo backend, atualizar estado de UI
      set({
        usuario: {
          usuarioId: data.usuarioId,
          nome: data.nome,
          email: data.email,
          papel: data.papel,
        },
        isAutenticado: true,
        isLoading: false,
      });
      return data;
    } catch (error) {
      set({
        erro: typeof error === 'string' ? error : error?.message || 'Erro ao fazer login',
        isLoading: false,
      });
      throw error;
    }
  },

  verify2FA: async (codigo) => {
    const { emailTemporario, mfaTokenTemporario } = get();
    set({ isLoading: true, erro: null });
    try {
      const data = await authService.verify2FA(emailTemporario, codigo, mfaTokenTemporario);

      set({
        usuario: {
          usuarioId: data.usuarioId,
          nome: data.nome,
          email: data.email,
          papel: data.papel,
        },
        isAutenticado: true,
        isLoading: false,
        emailTemporario: null,
        mfaTokenTemporario: null,
      });
      return data;
    } catch (error) {
      set({
        erro: typeof error === 'string' ? error : error?.message || 'Código 2FA inválido',
        isLoading: false,
      });
      throw error;
    }
  },

  logout: async () => {
    // Chamada assíncrona: o backend invalida o cookie antes de limparmos o estado
    await authService.logout();
    set({
      usuario: null,
      isAutenticado: false,
      erro: null,
      emailTemporario: null,
      mfaTokenTemporario: null,
    });
  },

  clearError: () => set({ erro: null }),
}));